var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibleLocal),expression:"visibleLocal"}],staticClass:"alert margin-15",class:[_vm.alertType, ]},[_c('div',{staticClass:"vertical-center align-text-center align-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }